import { Page } from 'layouts/Page';
import { FC } from 'react';
import { GpsrSku } from 'components/GpsrSku';

export const GpsrSkuPage: FC = () => {
	return (
		<Page title="GPSR Service – SKU – EAS Dashboard">
			<GpsrSku />
		</Page>
	);
};
